<template>
  <b-modal
    ref="getLayerFromFileModal"
    size="lg"
    centered
    title="Dodaj warstwę z pliku"
    @cancel="hide"
    @show="onShow"
    @hidden="hide"
  >
    <b-container>
      <b-row>
        <b-col md="12">
          <b-alert
            :show="step1ShowErrorDialog || step2ShowErrorDialog"
            variant="danger"
            class="w-100"
          >
            <b>Uwaga.</b> Formularz zawiera błędy.
          </b-alert>
          <b-alert :show="step1ShowFileError" variant="danger" class="w-100">
            <b>Uwaga.</b> {{ step1FileErrorMsg }}
          </b-alert>
          <b-alert
            :show="step1ShowApiErrorDialog"
            variant="danger"
            class="w-100"
          >
            <b>Uwaga.</b> {{ step1ApiErrorMsg }}
          </b-alert>
          <b-alert
            :show="step2ShowApiErrorDialog"
            variant="danger"
            class="w-100"
          >
            <b>Uwaga.</b> {{ step2ApiErrorMsg }}
          </b-alert>
          <b-alert
            :show="step1 && shpRequiredFileFormatsInfo"
            variant="info"
            class="w-100"
          >
            <b>Informacja.</b> {{ shpRequiredFileFormatsMsg }}
          </b-alert>
        </b-col>
      </b-row>
      <div v-show="step1">
        <b-row v-show="step1Errors.dataFormatNotChoosen">
          <b-col offset-md="5" md="7">
            <small class="text-danger"
              >Należy wybrać format danych przestrzennych.</small
            >
          </b-col>
        </b-row>
        <b-row v-show="gdbSelected">
          <b-col offset-md="5" md="7">
            <small class="text-info"
              >Plik gdb musi być spakowany do formatu zip.</small
            >
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="5">
            <label>Wybierz format danych przestrzennych</label>
          </b-col>
          <b-col md="7">
            <b-select
              v-model="choosenDataFormat"
              :state="step1Errors.dataFormatNotChoosen ? false : null"
            >
              <option value="">Wybierz</option>
              <option
                v-for="dataFormat in dataFormats"
                :key="dataFormat.value"
                :value="dataFormat.value"
              >
                {{ dataFormat.name }}
              </option>
            </b-select>
          </b-col>
        </b-row>
        <div v-show="choosenDataFormat == 'geotiff'">
          <b-row class="mb-2">
            <b-col md="5">
              <label>Uwzględnij podczas snapowania</label>
            </b-col>
            <b-col md="7">
              <b-form-checkbox v-model="snap"></b-form-checkbox>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="5">
              <label>Wyświetl jako Numeryczny Model Terenu</label>
            </b-col>
            <b-col md="7">
              <b-form-checkbox v-model="is_dtm"></b-form-checkbox>
            </b-col>
          </b-row>
        </div>
        <b-row v-show="step1Errors.dataCodingFormatNotChoosen">
          <b-col offset-md="5" md="7">
            <small class="text-danger">Należy wybrać kodowanie znaków.</small>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="5">
            <label>Wybierz kodowanie znaków</label>
          </b-col>
          <b-col md="7">
            <b-select
              v-model="choosenCodingFormat"
              :state="step1Errors.dataCodingFormatNotChoosen ? false : null"
            >
              <option value="">Wybierz</option>
              <option
                v-for="dataCoding in dataCodings"
                :key="dataCoding.value"
                :value="dataCoding.value"
              >
                {{ dataCoding.name }}
              </option>
            </b-select>
          </b-col>
        </b-row>

        <b-row v-show="step1Errors.geometryNotChoosen" v-if="showGeometryInput">
          <b-col offset-md="5" md="7">
            <small class="text-danger">Należy wybrać rodzaj geometrii.</small>
          </b-col>
        </b-row>
        <b-row class="mb-2" v-if="showGeometryInput">
          <b-col md="5">
            <label>Wybierz rodzaj geometrii</label>
          </b-col>
          <b-col md="7">
            <b-select
              v-model="choosenGeometry"
              :state="step1Errors.geometryNotChoosen ? false : null"
            >
              <option value="">Wybierz</option>
              <option
                v-for="geometry in geometries"
                :key="geometry.value"
                :value="geometry.value"
              >
                {{ geometry.name }}
              </option>
            </b-select>
          </b-col>
        </b-row>

        <b-row v-if="choosenGeometry && !canParseCsvFile">
          <b-col cols>
            <p class="text-info">
              Aby wybrać kolumnę (WKT) bądź kolumny (XY) określające geometrię,
              należy wybrać kodowanie znaków i plik w celu jego analizy.
            </p>
          </b-col>
        </b-row>

        <b-row v-show="step1Errors.xIsEmpty" v-if="showXYInput">
          <b-col offset="5" md="7">
            <small class="text-danger">Należy podać wartość X.</small>
          </b-col>
        </b-row>
        <b-row v-show="step1Errors.xNotHaveHeader" v-if="showXYInput">
          <b-col offset="5" md="7">
            <small class="text-danger">Brak podanego nagłówka w pliku.</small>
          </b-col>
        </b-row>
        <b-row class="mb-2" v-if="showXYInput">
          <b-col md="5">
            <label>Współrzędne X obiektów punktowych</label>
          </b-col>
          <b-col md="7">
            <!-- <b-input v-model="x" type="text" maxlength="255" :state="step1Errors.xIsEmpty||step1Errors.xNotHaveHeader ? false : null"></b-input> -->

            <b-select
              v-model="x"
              :state="
                step1Errors.xIsEmpty || step1Errors.xNotHaveHeader
                  ? false
                  : null
              "
            >
              <option value="">Wybierz</option>
              <option
                v-for="csvColumnHeader in csvColumnHeaders"
                :key="csvColumnHeader"
                :value="csvColumnHeader"
              >
                {{ csvColumnHeader }}
              </option>
            </b-select>
          </b-col>
        </b-row>

        <b-row v-show="step1Errors.yIsEmpty" v-if="showXYInput">
          <b-col offset="5" md="7">
            <small class="text-danger">Należy podać wartość Y.</small>
          </b-col>
        </b-row>
        <b-row v-show="step1Errors.yNotHaveHeader" v-if="showXYInput">
          <b-col offset="5" md="7">
            <small class="text-danger">Brak podanego nagłówka w pliku.</small>
          </b-col>
        </b-row>
        <b-row class="mb-2" v-if="showXYInput">
          <b-col md="5">
            <label>Współrzędne Y obiektów punktowych</label>
          </b-col>
          <b-col md="7">
            <!-- <b-input v-model="y" type="text" maxlength="255" :state="step1Errors.yIsEmpty||step1Errors.yNotHaveHeader ? false : null"></b-input> -->

            <b-select
              v-model="y"
              :state="
                step1Errors.yIsEmpty || step1Errors.yNotHaveHeader
                  ? false
                  : null
              "
            >
              <option value="">Wybierz</option>
              <option
                v-for="csvColumnHeader in csvColumnHeaders"
                :key="csvColumnHeader"
                :value="csvColumnHeader"
              >
                {{ csvColumnHeader }}
              </option>
            </b-select>
          </b-col>
        </b-row>

        <b-row v-show="step1Errors.wktIsEmpty" v-if="showWKTInput">
          <b-col offset="5" md="7">
            <small class="text-danger">Należy podać wartość WKT.</small>
          </b-col>
        </b-row>
        <b-row v-show="step1Errors.wktNotHaveHeader" v-if="showWKTInput">
          <b-col offset="5" md="7">
            <small class="text-danger">Brak podanego nagłówka w pliku.</small>
          </b-col>
        </b-row>
        <b-row class="mb-2" v-if="showWKTInput">
          <b-col md="5">
            <label>WKT</label>
          </b-col>
          <b-col md="7">
            <!-- <b-input v-model="wkt" type="text" maxlength="255" :state="step1Errors.wktIsEmpty||step1Errors.wktNotHaveHeader ? false : null"></b-input> -->

            <b-select
              v-model="wkt"
              :state="
                step1Errors.wktIsEmpty || step1Errors.wktNotHaveHeader
                  ? false
                  : null
              "
            >
              <option value="">Wybierz</option>
              <option
                v-for="csvColumnHeader in csvColumnHeaders"
                :key="csvColumnHeader"
                :value="csvColumnHeader"
              >
                {{ csvColumnHeader }}
              </option>
            </b-select>
          </b-col>
        </b-row>

        <b-row v-show="step1Errors.layerFileNotChoosen">
          <b-col md="12">
            <small class="text-danger">Należy wybrać plik.</small>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <div
              class="drop"
              :class="{
                dragging: isDragging,
                noFileChoosen: step1Errors.layerFileNotChoosen
              }"
              @dragenter="onDragEnter"
              @dragleave="onDragLeave"
              @dragover.prevent
              @drop="onDrop"
            >
              <div class="selectFile">
                <b-row class="justify-content-center">
                  <span>Przeciągnij i upuść plik tutaj</span>
                </b-row>
                <b-row class="justify-content-center">
                  <span>lub</span>
                </b-row>
                <b-row class="justify-content-center">
                  <div class="file btn btn-primary">
                    Wybierz plik
                    <input
                      ref="fileInput"
                      class="dragDropInput"
                      type="file"
                      name="file"
                      @change="onSelectFile"
                      :accept="fileInputAcceptAttributeValue"
                      :multiple="choosenDataFormat == 'shp'"
                    />
                  </div>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
        <div v-show="filesExist">
          <b-row
            class="mt-2"
            v-for="(fileName, index) in fileNames"
            :key="index"
          >
            <b-col md="5"><span> Załadowano: </span></b-col>
            <b-col md="7"
              ><span class="uploadedFileName"> {{ fileName }}</span></b-col
            >
          </b-row>
        </div>
      </div>
      <div v-show="!step1">
        <b-row v-show="step2Errors.nameIsEmpty">
          <b-col offset="5" md="7">
            <small class="text-danger">Należy podać nazwę warstwy.</small>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="5">
            <label>Nazwa warstwy</label>
          </b-col>
          <b-col md="7">
            <b-input
              v-model="name"
              type="text"
              maxlength="66"
              :state="step2Errors.nameIsEmpty ? false : null"
              style="opacity:initial"
            ></b-input>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="5">
            <label>Rozpoznany układ współrzędnych</label>
          </b-col>
          <b-col md="7">
            <span>{{ identifiedCoordinateSystemText }}</span>
          </b-col>
        </b-row>
        <b-row v-show="step2Errors.coordinateSystemNotChoosen">
          <b-col offset="5" md="7">
            <small class="text-danger"
              >Należy wybrać układ współrzędnych.</small
            >
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="5">
            <label>Wybierz inny układ współrzędnych</label>
          </b-col>
          <b-col md="7">
            <b-select
              v-model="choosenCoordinateSystem"
              :state="step2Errors.coordinateSystemNotChoosen ? false : null"
            >
              <option value="">Wybierz</option>
              <option
                v-for="coordinateSystem in coordinateSystems"
                :key="coordinateSystem.value"
                :value="coordinateSystem.value"
              >
                {{ coordinateSystem.name }}
              </option>
            </b-select>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <div slot="modal-footer" class="w-100">
      <button
        class="btn float-right ml-2 btn-outline-secondary"
        v-show="step1"
        @click="hide"
      >
        Anuluj
      </button>
      <button
        class="btn btn-primary float-right"
        v-show="step1"
        @click="submitStep1()"
        :disabled="step1Submitting"
      >
        <span v-show="step1Submitting">
          <icon name="circle-notch" spin />
        </span>
        <span v-show="!step1Submitting">
          Dalej
        </span>
      </button>
      <b-link class="btn pl-0" @click="goBack" v-show="!step1">Powrót</b-link>
      <button
        class="btn float-right ml-2 btn-outline-secondary"
        v-show="!step1"
        @click="hide"
      >
        Anuluj
      </button>
      <button
        class="btn btn-primary float-right"
        v-show="!step1"
        @click="submitStep2()"
      >
        <span v-show="step2Submitting">
          <icon name="circle-notch" spin />
        </span>
        <span v-show="!step2Submitting">
          Dodaj
        </span>
      </button>
    </div>
  </b-modal>
</template>

<script>
import {
  FileDataFormats,
  FileCodingFormat,
  FileCoordinateSystems
} from '../common/mapEnums';
import {
  WINDOW_GET_LAYER_FROM_FILE_HIDE,
  APPEND_LAYER,
  LAYERS_LOADING_SET
} from '../store/mutations.type';
import { COMPOSITIONS_FETCH, FETCH_ALL_LAYERS } from '../store/actions.type';
import { Api as ApiPliki } from '../api/api-pliki.js';
import { Api as ApiWarstwy } from '../api/api-warstwy.js';
import MapLayerBuilder from '../models/MapLayerBuilder';
import { Drag, Drop } from 'vue-drag-drop';
import CancelablePromise from 'cancelable-promise';
import Papa from 'papaparse';

export default {
  name: 'GetLayerFromFileWindow',
  components: {
    Drag,
    Drop
  },
  data() {
    return {
      choosenDataFormat: '',
      choosenCodingFormat: '',
      dataFormats: FileDataFormats,
      dataCodings: FileCodingFormat,
      layerFile: null,
      name: '',
      identifiedCoordinateSystem: null,
      identifiedCoordinateSystemText: '',
      coordinateSystems: FileCoordinateSystems,
      choosenCoordinateSystem: '',
      geometries: [
        {
          value: 'wkt',
          name: 'WKT'
        },
        {
          value: 'xy',
          name: 'XY'
        }
      ],
      choosenGeometry: '',
      x: '',
      y: '',
      wkt: '',
      step1: true,
      step1Errors: {
        dataFormatNotChoosen: false,
        dataCodingFormatNotChoosen: false,
        layerFileNotChoosen: false,
        shpFileMissingFormats: '',
        geometryNotChoosen: false,
        xIsEmpty: false,
        yIsEmpty: false,
        xNotHaveHeader: false,
        yNotHaveHeader: false,
        wktIsEmpty: false,
        wktNotHaveHeader: false
      },
      step1ShowFileError: false,
      step1FileErrorMsg: '',
      step1ShowErrorDialog: false,
      step1ShowApiErrorDialog: false,
      step1ApiErrorMsg: '',
      step1Submitting: false,
      step2Errors: {
        nameIsEmpty: false,
        coordinateSystemNotChoosen: false
      },
      step2ShowErrorDialog: false,
      step2ShowApiErrorDialog: false,
      step2ApiErrorMsg: '',
      step2Submitting: false,
      cached: {
        dataFormat: '',
        dataCoding: '',
        layerFile: null,
        geometry: '',
        x: '',
        y: '',
        wkt: ''
      },
      userWentBack: false,
      dragCount: 0,
      isDragging: false,
      snap: false,
      is_dtm: false,
      isDropped: false,
      layerPromiseObject: null,
      csvColumnHeaders: [],
      shpRequiredFormats: ['shp', 'dbf', 'prj', 'shx'],
      shpRequiredFileFormatsInfo: false,
      shpRequiredFileFormatsMsg:
        'Wymagane pliki o rozszerzeniu: .shp, .dbf, .prj, .shx.'
    };
  },
  computed: {
    showGeometryInput() {
      return this.choosenDataFormat == 'csv';
    },
    showXYInput() {
      return (
        this.showGeometryInput &&
        this.choosenGeometry == 'xy' &&
        this.hasCsvColumns
      );
    },
    showWKTInput() {
      return (
        this.showGeometryInput &&
        this.choosenGeometry == 'wkt' &&
        this.hasCsvColumns
      );
    },
    filesExist() {
      return this.layerFile != null && this.layerFile.length > 0;
    },
    fileNames() {
      return this.layerFile != null && this.layerFile.length > 0
        ? this.layerFile.map(x => x.name)
        : [];
    },
    canParseCsvFile() {
      return (
        this.choosenDataFormat == 'csv' &&
        this.layerFile != null &&
        this.layerFile.length > 0 &&
        this.choosenCodingFormat != ''
      );
    },
    hasCsvColumns() {
      return this.csvColumnHeaders.length;
    },
    gdbSelected() {
      return this.choosenDataFormat == 'gdb';
    },
    fileInputAcceptAttributeValue() {
      if (this.choosenDataFormat) {
        switch (this.choosenDataFormat) {
          case '':
            return null;
          case 'shp':
            return '.dbf, .prj, .shp, .shx';
          case 'geotiff':
            return '.tiff, .tif';
          default:
            return `.${this.choosenDataFormat}`;
        }
      }
      return null;
    }
  },
  methods: {
    onSelectFile(e) {
      this.clearErrors();
      this.resetGeometryValues();
      const files = e.target.files;
      this.layerFile = this.validateFiles(files) ? Array.from(files) : [];
      if (this.choosenDataFormat == 'csv') {
        this.parseCsv();
      }
    },
    parseCsv() {
      const self = this;
      Papa.parse(this.layerFile[0], {
        header: true,
        preview: 1,
        encoding: self.dataCoding,
        complete: (results, file) => {
          self.csvColumnHeaders = results.meta.fields;
        },
        error: (error, file) => {
          self.step1ApiErrorMsg = 'Błąd analizy pliku CSV.';
          self.step1ShowApiErrorDialog = true;
        }
      });
    },
    onDragEnter(e) {
      e.preventDefault();
      this.dragCount++;
      this.isDragging = true;
    },
    onDragLeave(e) {
      e.preventDefault();
      this.dragCount--;
      if (this.dragCount <= 0) {
        this.isDragging = false;
      }
    },
    onDrop(e) {
      this.clearErrors();
      this.resetGeometryValues();
      e.preventDefault();
      e.stopPropagation();
      const files = e.dataTransfer.files;
      this.layerFile = this.validateFiles(files) ? Array.from(files) : [];
      if (this.choosenDataFormat == 'csv') {
        this.parseCsv();
      }
      this.isDragging = false;
    },
    validateFiles(files) {
      var validate = true;
      if (this.choosenDataFormat != 'shp' && files.length > 1) {
        this.showErrorFileAlert(
          'Nie można dodać wiecej niż jednego pliku dla wybranego formatu.'
        );
        validate = false;
      } else if (this.choosenDataFormat == 'shp' && files.length != 4) {
        this.showErrorFileAlert(
          'Wymagana liczba plików dla formatu Shapefile wynosi 4.'
        );
        validate = false;
      } else if (this.choosenDataFormat == 'shp' && files.length == 4) {
        validate = this.validateShpFormat(files);
      }

      return validate;
    },
    validateShpFormat(files) {
      var files = Array.from(files);
      var fileformats = this.shpRequiredFormats;
      files.forEach(x => {
        var fileformat = x.name.split('.').pop();
        fileformats = fileformats.filter(format => format != fileformat);
      });
      fileformats = fileformats.map(x => '.' + x);
      if (fileformats.length != 0) {
        this.step1Errors.shpFileMissingFormats = fileformats.join(', ');
        this.showErrorFileAlert(
          'Brak plików o rozszerzeniu: ' +
            this.step1Errors.shpFileMissingFormats +
            '.'
        );
        return false;
      } else {
        this.step1Errors.shpFileMissingFormats = '';
      }

      return true;
    },
    showErrorFileAlert(msg, closeMessage) {
      var vm = this;
      this.step1ShowFileError = true;
      this.step1FileErrorMsg = msg;
      if (closeMessage) {
        setTimeout(() => {
          this.step1ShowFileError = false;
        }, 5000);
      }
    },
    hide() {
      this.layerPromiseObject = null;
      this.$store.commit(WINDOW_GET_LAYER_FROM_FILE_HIDE);
    },
    onShow() {
      this.choosenDataFormat = '';
      this.choosenCodingFormat = '';
      this.layerFile = null;
      this.layerFileId = '';
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
      this.name = '';
      this.identifiedCoordinateSystem = '';
      this.identifiedCoordinateSystemText = '';
      this.choosenCoordinateSystem = '';
      this.choosenGeometry = '';
      this.x = '';
      this.y = '';
      this.wkt = '';
      this.step1 = true;
      this.step1Errors = {
        dataFormatNotChoosen: false,
        dataCodingFormatNotChoosen: false,
        layerFileNotChoosen: false
      };
      this.step1Submitting = false;
      this.step1ShowErrorDialog = false;
      this.step1ShowApiErrorDialog = false;
      this.step2Errors = {
        nameIsEmpty: false,
        coordinateSystemNotChoosen: false
      };
      this.step2ShowErrorDialog = false;
      this.step2ShowApiErrorDialog = false;
      this.step1ShowFileError = false;
      this.cached = {
        dataFormat: '',
        dataCoding: '',
        layerFile: null
      };
      this.userWentBack = false;
      this.snap = false;
      this.is_dtm = false;
      this.csvColumnHeaders = [];
    },
    goBack() {
      this.userWentBack = true;
      this.step1 = true;
    },
    validateFormStep1() {
      this.step1ShowErrorDialog = false;
      this.step1ShowApiErrorDialog = false;

      this.step1Errors.dataFormatNotChoosen = !this.choosenDataFormat;
      this.step1Errors.dataCodingFormatNotChoosen = !this.choosenCodingFormat;
      this.step1Errors.layerFileNotChoosen =
        !this.layerFile && this.layerFile.layerFile > 0;

      if (this.choosenDataFormat == 'csv') {
        this.step1Errors.geometryNotChoosen = !this.choosenGeometry;
        if (this.choosenGeometry == 'xy') {
          this.step1Errors.xIsEmpty = !this.x;
          this.step1Errors.yIsEmpty = !this.y;
        } else if (this.choosenGeometry == 'wkt') {
          this.step1Errors.wktIsEmpty = !this.wkt;
        }
      }

      if (this.choosenDataFormat == 'csv') {
        if (this.choosenGeometry == 'xy') {
          this.step1ShowErrorDialog =
            this.step1Errors.dataFormatNotChoosen ||
            this.step1Errors.dataCodingFormatNotChoosen ||
            this.step1Errors.layerFileNotChoosen ||
            this.step1Errors.geometryNotChoosen ||
            this.step1Errors.xIsEmpty ||
            this.step1Errors.yIsEmpty;
        } else if (this.choosenGeometry == 'wkt') {
          this.step1ShowErrorDialog =
            this.step1Errors.dataFormatNotChoosen ||
            this.step1Errors.dataCodingFormatNotChoosen ||
            this.step1Errors.layerFileNotChoosen ||
            this.step1Errors.geometryNotChoosen ||
            this.step1Errors.wktIsEmpty;
        } else {
          this.step1ShowErrorDialog =
            this.step1Errors.dataFormatNotChoosen ||
            this.step1Errors.dataCodingFormatNotChoosen ||
            this.step1Errors.layerFileNotChoosen ||
            this.step1Errors.geometryNotChoosen;
        }
      } else {
        this.step1ShowErrorDialog =
          this.step1Errors.dataFormatNotChoosen ||
          this.step1Errors.dataCodingFormatNotChoosen ||
          this.step1Errors.layerFileNotChoosen ||
          this.step1Errors.shpFileMissingFormats != '';
      }
      return !this.step1ShowErrorDialog;
    },
    checkIfSystemShouldCallApi() {
      // jesli użytkownik wrócił i nie wprowadził zmian
      // nie należy ponownie uploadować tego samego pliku
      if (!this.userWentBack) {
        return true;
      } else {
        if (
          this.cached.dataFormat != this.choosenDataFormat ||
          this.cached.dataCoding != this.choosenCodingFormat ||
          this.cached.layerFile != this.layerFile ||
          this.cached.geometry != this.choosenGeometry ||
          this.cached.x != this.x ||
          this.cached.y != this.y ||
          this.cached.wkt != this.wkt
        ) {
          return true;
        }
      }
      return false;
    },
    getFiles() {
      var params = {};
      var counter = 1;
      this.layerFile.forEach(x => {
        params['file' + (counter != 1 ? counter : '')] = x;
        counter++;
      });
      return params;
    },
    async submitStep1() {
      if (this.validateFormStep1()) {
        if (this.checkIfSystemShouldCallApi()) {
          var vm = this;
          var api = new ApiPliki();
          this.clearErrors();
          this.step1Submitting = true;
          var params = this.getFiles();
          params['kodowanie'] = this.choosenCodingFormat;
          params['format'] = this.choosenDataFormat;
          params['x'] = this.x;
          params['y'] = this.y;
          params['wkt'] = this.wkt;
          vm.layerPromiseObject = new CancelablePromise(() =>
            api
              .postPlikiUzytkownika(params)
              .then(function(response) {
                vm.step1ShowApiErrorDialog = false;
                vm.step1ShowApiErrorDialog = false;
                vm.layerFileId = response.body.id;
                vm.identifiedCoordinateSystem = response.body.uklad;
                var identifiedSystemObjects = vm.coordinateSystems.filter(x => {
                  return x.value == response.body.uklad;
                });
                if (identifiedSystemObjects.length > 0) {
                  vm.identifiedCoordinateSystemText =
                    identifiedSystemObjects[0].name;
                } else {
                  vm.identifiedCoordinateSystemText = 'Nie rozpoznano';
                }
                vm.cached.dataFormat = vm.choosenDataFormat;
                vm.cached.dataCoding = vm.choosenCodingFormat;
                vm.cached.layerFile = vm.layerFile;
                vm.cached.geometry = vm.choosenGeometry;
                vm.cached.x = vm.x;
                vm.cached.y = vm.y;
                vm.cached.wkt = vm.wkt;
                vm.step1Submitting = false;
                vm.step1 = false;
                vm.layerPromiseObject = null;
              })
              .catch(function(error) {
                if (vm.layerPromiseObject != null) {
                  if (typeof error.response !== 'undefined') {
                    if (
                      error.body.error ==
                      'Błąd przetwarzania pliku. Wybierz inny plik. E: Features are empty or invalid geometry'
                    ) {
                      vm.step1ApiErrorMsg =
                        'Błąd przetwarzania pliku. Wybierz inny plik.';
                    } else if (
                      error.body.error ==
                      'Błąd przetwarzania pliku. Wybierz inny plik. E: brak podanego naglowka w pliku dla pola X'
                    ) {
                      vm.step1ApiErrorMsg =
                        'Błąd przetwarzania pliku. Wybierz inny plik.';
                      vm.step1Errors.xNotHaveHeader = true;
                    } else if (
                      error.body.error ==
                      'Błąd przetwarzania pliku. Wybierz inny plik. E: brak podanego naglowka w pliku dla pola Y'
                    ) {
                      vm.step1ApiErrorMsg =
                        'Błąd przetwarzania pliku. Wybierz inny plik.';
                      vm.step1Errors.yNotHaveHeader = true;
                    } else if (
                      error.body.error ==
                      'Błąd przetwarzania pliku. Wybierz inny plik. E: brak podanego naglowka w pliku dla pola WKT'
                    ) {
                      vm.step1ApiErrorMsg =
                        'Błąd przetwarzania pliku. Wybierz inny plik.';
                      vm.step1Errors.wktNotHaveHeader = true;
                    } else if (
                      error.body.error ==
                      'Błąd przetwarzania pliku. Wybierz inny plik. E: brak podanego naglowka w pliku dla pola X i Y'
                    ) {
                      vm.step1ApiErrorMsg =
                        'Błąd przetwarzania pliku. Wybierz inny plik.';
                      vm.step1Errors.xNotHaveHeader = true;
                      vm.step1Errors.yNotHaveHeader = true;
                    } else {
                      vm.step1ApiErrorMsg = error.body.error + '.';
                    }
                  } else {
                    vm.step1ApiErrorMsg =
                      'Wystąpił błąd komunikacji z serwerem.';
                  }
                  vm.step1ShowApiErrorDialog = true;
                  vm.step1Submitting = false;
                }
                vm.layerPromiseObject = null;
              })
          );
          return false;
        } else {
          this.step1 = false;
        }
      }
    },
    validateFormStep2() {
      this.step2ShowErrorDialog = false;

      this.step2Errors.nameIsEmpty = !this.name;
      this.step2Errors.coordinateSystemNotChoosen =
        !this.choosenCoordinateSystem &&
        this.identifiedCoordinateSystem == null;

      this.step2ShowErrorDialog =
        this.step2Errors.nameIsEmpty ||
        this.step2Errors.coordinateSystemNotChoosen;

      return !this.step2ShowErrorDialog;
    },
    submitStep2() {
      if (this.validateFormStep2()) {
        var vm = this;
        var api = new ApiWarstwy();
        this.clearErrors();
        this.step2Submitting = true;
        this.$store.commit(LAYERS_LOADING_SET, true);

        api
          .postWarstwyUzytkownika({
            body: {
              id: this.layerFileId,
              nazwa: this.name,
              uklad:
                this.choosenCoordinateSystem != ''
                  ? this.choosenCoordinateSystem
                  : this.identifiedCoordinateSystem,
              snap: this.snap,
              is_dtm: this.is_dtm,
              kompozycja_id: this.$store.getters.composition.id
            }
          })
          .then(async function(response) {
            if (response) {
              if (response.body.ids_list && response.body.ids_list.length > 0) {
                response.body.ids_list.forEach(x => {
                  vm.addLayerToLegend(x);
                });
                await vm.$store.dispatch(FETCH_ALL_LAYERS, {
                  useStoredSettings: true
                });
                vm.showSuccessAlert();
              } else if (response.body.id) {
                vm.addLayerToLegend(response.body.id);
                await vm.$store.dispatch(FETCH_ALL_LAYERS, {
                  useStoredSettings: true
                });
                vm.showSuccessAlert();
              }
              vm.step2ShowApiErrorDialog = false;
              vm.step2Submitting = false;
              vm.hide();
            }
          })
          .catch(function(err) {
            vm.step2Submitting = false;
            vm.step2ShowApiErrorDialog = true;
            if (err.response !== 'undefined') {
              vm.step2ApiErrorMsg = err.body.error + '.';
            } else {
              vm.step2ApiErrorMsg = 'Wystąpił błąd komunikacji z serwerem.';
            }
            vm.resetForm();
          })
          .finally(_ => {
            this.$store.commit(LAYERS_LOADING_SET, false);
          });
      }
    },
    resetForm() {
      this.choosenDataFormat = '';
      this.choosenCodingFormat = '';
      this.layerFile = null;
      this.layerFileId = '';
      this.$refs.fileInput.value = '';
      this.name = '';
      this.identifiedCoordinateSystem = '';
      this.identifiedCoordinateSystemText = '';
      this.choosenCoordinateSystem = '';
      this.choosenGeometry = '';
      this.x = '';
      this.y = '';
      this.wkt = '';
      this.step1 = true;
      this.csvColumnHeaders = [];
    },
    resetGeometryValues() {
      this.x = '';
      this.y = '';
      this.wkt = '';
      if (this.step1ApiErrorMsg || this.choosenDataFormat != 'csv') {
        this.choosenGeometry = '';
        this.csvColumnHeaders = [];
      }
    },
    clearErrors() {
      this.step1ShowErrorDialog = false;
      this.step2ShowErrorDialog = false;
      this.step1ShowFileError = false;
      this.step1FileErrorMsg = '';
      this.step1ShowApiErrorDialog = false;
      this.step1ApiErrorMsg = '';
      this.step2ShowApiErrorDialog = false;
      this.step2ApiErrorMsg = '';
      this.step1Errors.xNotHaveHeader = false;
      this.step1Errors.yNotHaveHeader = false;
      this.step1Errors.wktNotHaveHeader = false;
      this.step1Errors.shpFileMissingFormats = '';
    },
    showSuccessAlert() {
      this.$notify({
        type: 'success',
        title: 'Sukces!',
        text: 'Dodawanie warstwy z pliku zakończone powodzeniem.',
        duration: 2000
      });
    },
    addLayerToLegend(layerId) {
      var vm = this;
      var api = new ApiWarstwy();
      api
        .getWarstwyById({
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId,
          id: layerId
        })
        .then(async function(response) {
          var layer = undefined;
          layer = await vm.createLayerObject(response);
          if (layer) {
            vm.$store.commit(APPEND_LAYER, layer);
          }
        });
    },
    async createLayerObject(response) {
      let coordinateSystem = this.$store.getters.coordinateSystem;
      var apiLayer = response.body.warstwy;
      var layer = {
        id: apiLayer.id,
        order: -1, //this value is used as z-index
        names: apiLayer.warstwy,
        legends: [],
        url: (apiLayer.usluga || {}).adres,
        datasource: apiLayer.datasource,
        title: apiLayer.nazwa,
        isSystem: apiLayer.systemowa,
        type: apiLayer.typ,
        visible: false,
        styleId: (apiLayer.styl || {}).id || '',
        createdStyleId: undefined,
        attributes: (apiLayer.pola || []).map(y => {
          y.displayed = y.visible;
          return y;
        }),
        active: false,
        expanded: false,
        modified: false,
        extent: apiLayer.extent,
        ownerId: apiLayer.wlasciciel
      };

      layer.defaultStyleId = layer.styleId;
      layer.mapLayer = await new MapLayerBuilder(
        layer,
        coordinateSystem
      ).getOlLayer();

      return layer;
    }
  },
  created() {
    let self = this;
    self.$store.watch(
      () => self.$store.getters.getLayerFromFileWindowVisible,
      (value, oldValue) => {
        let modal = self.$refs.getLayerFromFileModal;
        let method = value ? modal.show : modal.hide;
        method.call(modal);
      }
    );
  },
  watch: {
    choosenDataFormat(value, oldValue) {
      this.clearErrors();
      this.resetGeometryValues();
      this.choosenDataFormat = value;
      if (oldValue == 'shp') {
        this.layerFile = [];
      }

      this.shpRequiredFileFormatsInfo = value == 'shp';
    },
    step1(value) {
      if (value == true) {
        this.step2Errors.nameIsEmpty = false;
        this.step2Errors.coordinateSystemNotChoosen = false;
      } else {
        this.step1Errors.dataFormatNotChoosen = false;
        this.step1Errors.dataCodingFormatNotChoosen = false;
        this.step1Errors.layerFileNotChoosen = false;
        this.step1Errors.geometryNotChoosen = false;
        this.step1Errors.xIsEmpty = false;
        this.step1Errors.yIsEmpty = false;
        this.step1Errors.wktIsEmpty = false;
      }
    },
    canParseCsvFile(value) {
      if (value) {
        this.parseCsv();
      }
    }
  }
};
</script>

<style>
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: 'Wybierz plik';
}
.drop {
  width: 100%;
  height: 200px;
  background: #e6e6e6;
  text-align: center;
  border-radius: 3px;
  border: 1px dashed #a0a0a0;
  position: relative;
}
.dragging {
  background: #f3f3f3ce;
}
.noFileChoosen {
  border: 1px solid red;
}
.selectFile {
  position: absolute;
  top: 20%;
  margin-left: 40%;
}
.dragDropText {
  word-break: break-word;
  align-self: center;
  max-height: 1.75em;
  overflow: hidden;
}
.uploadedFileName {
  float: right;
  word-break: break-word;
  align-self: center;
  max-height: 1.75em;
  overflow: hidden;
}
.file.btn.btn-primary {
  position: relative;
  overflow: hidden;
  margin-left: 10px;
}
.dragDropInput {
  font-size: 50px;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.fas.fa-file {
  font-size: 1.25em;
  margin-right: 5px;
}
.row.uploadedFile div.col {
  max-width: fit-content;
  padding-left: 0px;
  padding-right: 0px;
}
</style>
